import React, { createContext, useContext, useState } from "react";

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  
  const [data, setData] = useState({}); // تمام داده‌ها در یک شیء ذخیره می‌شوند.


  const updateData = (key, value) => {
    
    setData((prev) => ({
      ...prev,
      [key]: value, // ذخیره هر API در یک کلید خاص
    }));
  };

  return (
    <DataContext.Provider value={{ data, updateData}}>
      {children}
    </DataContext.Provider>
  );
};

export const useDataContext = () => useContext(DataContext);
